import React, { useEffect, useMemo, useState } from 'react';
import { useParams, Navigate, Outlet, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from './Navbar';
import Footer from './Footer';
import EmailCaptureModal from './EmailCaptureModal';
import { APP_STATUS, APP_TYPE, findCatalogItemById } from '../constants/apps';

const PageLayout = () => {
  const { lang } = useParams();
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [emailCaptureApp, setEmailCaptureApp] = useState(null);

  const normalizeProductId = (product) => {
    if (!product) return null;
    const aliases = {
      chat: 'infinia_chat',
      'npu-check': 'npu_check',
      'npu-agent': 'npu_agent',
      'npu-chat': 'infinia_chat'
    };
    return aliases[product] || product;
  };

  const openDownload = (product = null) => {
    const productId = normalizeProductId(product);

    if (!productId) {
      navigate(`/${lang}/download`);
      return;
    }

    const app = findCatalogItemById(productId);

    if (!app) {
      navigate(`/${lang}/download`);
      return;
    }

    if (app.status !== APP_STATUS.LIVE) {
      setEmailCaptureApp(app.id);
      setIsEmailModalOpen(true);
    } else {
      const pathBase = app.type === APP_TYPE.TOOL ? 'tools' : 'apps';
      navigate(`/${lang}/${pathBase}/${app.pageRoute}#downloads`);
    }
  };
  
  const supportedLangs = useMemo(() => ['en', 'es'], []);

  useEffect(() => {
    if (supportedLangs.includes(lang) && i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n, supportedLangs]);

  if (!supportedLangs.includes(lang)) {
    // If language is invalid, redirect to browser language or default English
    const browserLang = navigator.language.split('-')[0];
    const targetLang = browserLang === 'es' ? 'es' : 'en';
    return <Navigate to={`/${targetLang}`} replace />;
  }

  return (
    <div className="app-container">
      <div className="glow-bg" />
      <Navbar onDownloadClick={openDownload} />
      <main id="main-content" className="main-content">
        <Outlet context={{ onDownloadClick: openDownload }} />
      </main>
      <Footer />
      <EmailCaptureModal
        isOpen={isEmailModalOpen}
        onClose={() => setIsEmailModalOpen(false)}
        primaryApp={emailCaptureApp}
        secondaryApps={[]}
        showCompatibleMessage={false}
      />
    </div>
  );
};

export default PageLayout;
